/*部门 */
import { $http, buildHeaders } from "./index";

//获取列表
export const department_index = (params) => {
  return $http.get("/admin/Department/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const department_detail = (id) => {
  return $http.get("/admin/Department/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加
export const department_add = (data) => {
  return $http.post("/admin/Department/add", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//修改
export const department_edit = (data) => {
  return $http.post("/admin/Department/edit", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//删除
export const department_delete = (id) => {
  return $http.post(
    "/admin/Department/del",
    { id },
    {
      headers: buildHeaders(3, "正在删除数据，请稍后……"),
    },
  );
};
